import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

const { Item } = Form;

export const InputDocument: CSSProperties = {
  height: theme["@height-button-lg"],
};

export const FormItem = styled(Item)`
  .ant-input {
    margin-left: 0;
    font-size: ${(props) => props.theme["@medium-font-size"]};
  }

  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    padding: 3px 0;
    z-index: 1;
    > label {
      font-family: ${(props) => props.theme["@font-family"]};
      font-weight: ${(props) => props.theme["@bold-font-weight"]};
      font-size: ${(props) => props.theme["@medium-font-size"]};
      pointer-events: none !important;
      :hover {
        pointer-events: none !important;
      }
    }
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid ${(props) => props.theme.colors.manatee} !important;
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-form-item-control {
    width: 100%;
  }

  &.ant-form-item-control-input > button {
    width: 100%;
  }

  .ant-slider-mark-text {
    white-space: pre;
  }
`;

export const LayoutForm = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-row-gap: 0px;
`;

export const FormLayout: CSSProperties = {
  height: "100%",
};

export const CheckDescription: CSSProperties = {
  maxWidth: "100%",
  fontFamily: theme["@font-family"],
  fontWeight: theme["@normal-font-weight"],
  padding: "3px 0",
  zIndex: 1,
  marginRight: "5px",
  fontSize: theme["@medium-font-size"],
};

export const CheckSwitch: CSSProperties = {
  width: "20%",
};

export const MaskContainer = styled.div`
  display: grid;
  grid-template-columns: 0.9fr 0.9fr 1fr;
  align-items: center;
  width: 100%;
  margin: auto;
`;

export const MaskCharactersContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  margin: auto;
  width: 95%;
  margin-top: 40px;
`;
